module.exports = __webpack_public_path__ + "static/img/Sub beam 4,8m,,3.0m,,2,4m (hollow 40x40).192d200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Sub beam 4,8m,,3.0m,,2,4m (hollow 40x40).jpg
// module id = 103
// module chunks = 1